import { CalendarDate, parseDate } from "@internationalized/date";

const getCalendarDate = (date: string | Date): CalendarDate | null => {
    if (!date) {
        return null;
    }

    const parsedDate = typeof date === "string" ? new Date(date) : date;

    if (Number.isNaN(parsedDate.getTime())) {
        return null;
    }

    return new CalendarDate(
        parsedDate.getFullYear(),
        parsedDate.getMonth() + 1,
        parsedDate.getDate(),
    );
};

const getAllCalendarDateMonthsBetween = (
    start: CalendarDate,
    end: CalendarDate,
) => {
    const dates = [];
    let current = start;

    while (
        current.year < end.year ||
        (current.year === end.year && current.month <= end.month)
    ) {
        dates.push(current);
        current = current.add({ months: 1 });
    }

    return dates;
};

const parseCalendarDate = (date: string | Date): CalendarDate | null => {
    if (!date) {
        return null;
    }

    if (typeof date === "string") {
        return parseDate(date);
    }

    return new CalendarDate(
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate(),
    );
};

const safeParseDate = (date: string | Date): Date | null => {
    if (!date) {
        return null;
    }

    const parsedDate = typeof date === "string" ? new Date(date) : date;

    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

const getMaxDate = (...dates: (Date | string)[]): Date | null => {
    if (!dates || dates.length === 0) {
        return null;
    }

    const parsedDates = dates
        .map(safeParseDate)
        .filter((date): date is Date => date !== null);

    return parsedDates.reduce((max, date) => {
        if (!date || Number.isNaN(date.getTime())) {
            return max;
        }
        return date > max ? date : max;
    }, new Date(0));
};

const getMinDate = (...dates: (Date | string)[]): Date | null => {
    if (!dates || dates.length === 0) {
        return null;
    }

    const parsedDates = dates
        .map(safeParseDate)
        .filter((date): date is Date => date !== null);

    return parsedDates.reduce((min, date) => {
        if (!date || Number.isNaN(date.getTime())) {
            return min;
        }
        return date < min ? date : min;
    }, new Date(0));
};

export {
    getAllCalendarDateMonthsBetween,
    getCalendarDate,
    getMaxDate,
    getMinDate,
    parseCalendarDate,
};
